module.exports = __webpack_public_path__ + "img/novelphoneone.0ff1cdf5.png";